import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { publicViewsTranslations } from '../i18n/translations';

const FUNCTIONS_BASE_URL = 'https://us-central1-mendyx-adafe.cloudfunctions.net';

const functionUrl = (name, params = {}) => {
  const url = new URL(`${FUNCTIONS_BASE_URL}/${name}`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
};

const ClassementView = () => {
  const { language } = useLanguage();
  const t = createTranslator(language, publicViewsTranslations);
  const { leagueId } = useParams();
  const [teamsRanking, setTeamsRanking] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClassement = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          functionUrl('protectedGetLeaguePublicClassement', { leagueId })
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Erreur serveur');
        }

        setTeamsRanking(data.ranking || []);
      } catch (error) {
        console.error('Erreur lors de la récupération du classement :', error);
        setTeamsRanking([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClassement();
  }, [leagueId]);

  if (loading) {
    return <p>{t('loading')}</p>;
  }

  return (
    <div className="container mx-auto my-16 px-4">
      <h2 className="text-3xl font-semibold text-center text-[#800020] mb-8">
        {t('leagueRanking', { id: leagueId })}
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-400 text-sm">
          <thead className="bg-[#800020] text-white">
            <tr>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('rank')}</th>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('name')}</th>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('points')}</th>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('wins')}</th>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('losses')}</th>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('gamesWon')}</th>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('gamesLost')}</th>
              <th className="border border-gray-400 px-2 py-1 text-left">{t('diff')}</th>
            </tr>
          </thead>
          <tbody>
            {teamsRanking.map((team, index) => (
              <tr key={team.teamName || index} className="hover:bg-gray-50 transition-colors">
                <td className="border border-gray-400 px-2 py-1 text-center">{index + 1}</td>
                <td className="border border-gray-400 px-2 py-1">{team.teamName}</td>
                <td className="border border-gray-400 px-2 py-1 text-center">{team.points}</td>
                <td className="border border-gray-400 px-2 py-1 text-center">{team.wins}</td>
                <td className="border border-gray-400 px-2 py-1 text-center">{team.losses}</td>
                <td className="border border-gray-400 px-2 py-1 text-center">{team.gamesWon}</td>
                <td className="border border-gray-400 px-2 py-1 text-center">{team.gamesLost}</td>
                <td className="border border-gray-400 px-2 py-1 text-center">{team.gamesDiff}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClassementView;
